var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApiPromise } from "@polkadot/api";
import { HttpProvider, WsProvider } from "@polkadot/rpc-provider";
import { TypeRegistry } from "@polkadot/types";
import * as definitions from "./interfaces/definitions";
import { DefaultInterBtcApi } from "./interbtc-api";
export function createProvider(endpoint, autoConnect) {
    if (/https?:\/\//.exec(endpoint)) {
        return new HttpProvider(endpoint);
    }
    if (/wss?:\/\//.exec(endpoint)) {
        return new WsProvider(endpoint, autoConnect);
    }
    throw new Error(`unknown scheme for ${endpoint}`);
}
export function createSubstrateAPI(endpoint, autoConnect, noInitWarn) {
    const provider = createProvider(endpoint, autoConnect);
    const types = getAPITypes();
    const rpc = getRPCTypes();
    return ApiPromise.create({
        provider,
        types,
        rpc,
        noInitWarn: noInitWarn || true,
    });
}
export function createInterBtcApi(endpoint, network = "mainnet", account, autoConnect) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = yield createSubstrateAPI(endpoint, autoConnect);
        return new DefaultInterBtcApi(api, network, account);
    });
}
export function getAPITypes() {
    return Object.values(definitions).reduce((res, { types }) => (Object.assign(Object.assign({}, res), types)), {});
}
export function getRPCTypes() {
    return Object.values(definitions).reduce((res, { providerRpc }) => (Object.assign(Object.assign({}, res), providerRpc)), {});
}
export function createAPIRegistry() {
    const registry = new TypeRegistry();
    registry.register(getAPITypes());
    return registry;
}
//# sourceMappingURL=factory.js.map